import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Select from "react-select";
import _ from "lodash";
import Actions from "../../../Actions";
import logger from "../../../utils/LoggerFrontend";
import { QuestionsMapping } from "./questions-mapping/QuestionsMapping";

const Wrapper = styled.div`
  height: 600px;
`;

export const RecruiteeIntegration = ({
  organization: {
    integrations: { recruitee },
    name,
    id: orgaId
  },
  campaignData,
  campaignId,
  onSaveIntegration
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState(campaignData?.integrations?.recruitee?.jobId);
  const [jobName, setJobName] = useState(campaignData?.integrations?.recruitee?.jobName);

  logger.log("RecruiteeIntegration", "called", {
    recruitee,
    name,
    campaignData
  });

  useEffect(() => {
    const unsubscribeUpdateCampaign = Actions.updateCampaignWithId.completed.listen(() => {
      Actions.addNotification("Synchronisierung erfolgreich");
    });

    const unsubscribeUpdateCampaignFailed = Actions.updateCampaignWithId.failed.listen((error) => {
      logger.log("error:RecruiteeIntegration", "unable to connect with recruitee job", {
        error
      });

      Actions.addNotification("Synchronisierung nicht erfolgreich", "error");
    });

    const ref = Actions.getRecruiteeJobs.completed.listen((data) => {
      logger.log("RecruiteeIntegration", "fetched recruitee jobs", { data });
      const jobs = data.payload;

      setJobs(jobs);
      setIsLoading(false);
      ref();
    });

    const refFailed = Actions.getRecruiteeJobs.failed.listen(({ error }) => {
      logger.log("error:RecruiteeIntegration", "unbable to fetch recruitee jobs", { error });
      setIsLoading(false);
      refFailed();
    });

    Actions.getRecruiteeJobs({ campaignId });

    return () => {
      unsubscribeUpdateCampaign();
      unsubscribeUpdateCampaignFailed();
    };
  }, [recruitee]);

  const options = jobs.map(({ id, title }) => ({
    value: id,
    label: `${title} (ID: ${id})`
  }));

  logger.log("RecruiteeIntegration", "options", { options });

  const onChange = ({ value, label }) => {
    setJobId(value);
    setJobName(label);
    const update = {
      integrations: { recruitee: { ...recruitee, jobId: value, jobName: label } }
    };
    Actions.updateCampaignWithId(campaignId, update);
    onSaveIntegration && onSaveIntegration(update);
  };

  const currentlySelected = _.filter(options, { value: jobId })[0];

  logger.log("Campaign__Read_Integration", "options", {
    options,
    currentlySelected,
    jobId,
    jobName
  });

  if (isLoading) {
    return <div>Loading... </div>;
  }

  if (!jobs || jobs.length === 0) {
    return (
      <Wrapper>
        <h3>{name} - Recruitee</h3>
        ....
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h3>{name} - Recruitee</h3>
      <Select options={options} value={currentlySelected} onChange={onChange} />
      <QuestionsMapping
        offerId={jobId}
        campaignId={campaignId}
        orgaId={orgaId}
        currentlySelected={currentlySelected}
        currentQuestionMapping={campaignData?.integrations?.recruitee?.questionMapping}
      />
    </Wrapper>
  );
};
